import PropTypes from 'prop-types';
import dayjs from 'dayjs';
// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// components
import { FormHelperText, TextField } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';

// ----------------------------------------------------------------------

RHFTimePicker.propTypes = {
  name: PropTypes.string.isRequired,
};

export default function RHFTimePicker({ name, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => {
        const value = field.value ? dayjs(field.value, 'HH:mm') : null;
        // const checkError = !!error && !field.value;
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div>
              <TimePicker
                renderInput={(params) => (
                  <TextField {...params} fullWidth error={!!error} helperText={error?.message} />
                )}
                {...field}
                value={value}
                onChange={(newValue) => field.onChange(newValue ? newValue.format('HH:mm') : '')}
                {...other}
                ampm={false}
                minutesStep={1}
                slotProps={{
                  textField: {
                    style: {
                      backgroundColor: '#FFFFFF',
                      borderRadius: 0,
                      width: '100%',
                      border: 0,
                    },
                  },
                }}
              />
              {error?.message && (
                <FormHelperText error sx={{ px: 2, textAlign: 'leftAlign' }}>
                  {error.message}
                </FormHelperText>
              )}
            </div>
          </LocalizationProvider>
        );
      }}
    />
  );
}
